import {Component, Input} from '@angular/core';
import {CsIconModule} from '@components/icon';
import {Regimen} from '@cureskin/api-client/src/server-api';

@Component({
  selector: 'app-report-treatment-plan',
  imports: [
    CsIconModule
  ],
  templateUrl: './report-treatment-plan.component.html',
})

export class ReportTreatmentPlanComponent {
  @Input() allocatedDoctorImage: string;
  @Input() displayConcern: string;
  @Input() languagePreference: string;
  @Input() regimen: Regimen & { displayConcern?: { name?: string } };
  @Input() experiment: any;

  private get allProducts(): any[] {
    return [...(this.regimen?.morning || []), ...(this.regimen?.night || [])];
  }

  get repairIngredients(): any[] {
    return this.allProducts
      .filter(item => item?.product?.isRepair)
      .flatMap(item => item.product?.heroIngredients || [])
      .filter((ing, i, arr) => arr.findIndex(x => x?.objectId === ing?.objectId) === i);
  }

  get facewashSentence(): string {
    const facewashMap = this.experiment?.FACEWASH_MAP || {};
    const objectId = this.allProducts
      .find(item => item?.product?.objectId in facewashMap)
      ?.product?.objectId;
    return facewashMap[objectId]?.[this.languagePreference] ?? '';
  }

  get supplementDescription(): string {
    const supplementMap = this.experiment?.SUPPLEMENT_MAP || {};
    const objectId = this.allProducts
      .find(item => item?.product?.objectId in supplementMap)
      ?.product?.objectId;
    return supplementMap[objectId]?.[this.languagePreference] ?? '';
  }
}
